module.exports = __webpack_public_path__ + "static/media/icon-arrow-triangle.e90ca004.svg";